// extracted by mini-css-extract-plugin
module.exports = {"container":"Overlay_container__1Muxt","default":"Overlay_default__10hTB","light":"Overlay_light__1l5Aq"};